import { CheckboxField } from '@calendly/form'
import { I18n } from '@calendly/i18n'

import { selectById, useFetchCalendarAccountsQuery } from 'features/calendar_connections/api'

import { Label } from '../elements'
import { Option } from './option'

export const UnavailableStatuses = ({ id }) => {
  const { data } = useFetchCalendarAccountsQuery()
  const { name, canSelectUnavailableStatus, localizedUnavailableStatuses } = selectById(data, id)

  if (!canSelectUnavailableStatus) return null

  return (
    <>
      <Label>
        {I18n.t('publisher.calendar.consider_me_unavailable', { provider: name })}
      </Label>
      {
        localizedUnavailableStatuses.map(({ id: calendarId, name: calendarLabel, forced }) => (
          <Option key={calendarId}>
            <CheckboxField
              name="unavailableStatuses"
              label={calendarLabel}
              value={calendarId}
              disabled={forced}
            />
          </Option>
        ))
      }
    </>
  )
}
